import { combineReducers } from 'redux';
import { SetAllProducts, SetProduct } from './reducer_product';
import { CurrentBooking, BookingLoading } from './reducer_currentBooking';
import { SetCapacity } from './reducer_capacity';
import { SetCities, SetCityDepartures } from './reducer_cities';
import { SetNextDestinations } from './reducer_destinations';
import { SetCart } from './reducer_cart';
import { SetCountries, SetState } from './reducer_nationality';
import { SetForms, SetValidation } from './reducer_form';
import { ToggleModal, ToggleSlidePanel } from './reducer_modal';
import { FetchCurrency } from './reducer_currency';
import { SetHotel } from './reducer_hotel';

const rootReducer = combineReducers({
    currency:FetchCurrency,
    products:SetAllProducts, //all products
    product:SetProduct, //single product
    currentBooking:CurrentBooking,
    capacity:SetCapacity,
    cities:SetCities,
    allDepartures:SetCityDepartures,
    nextDestinations:SetNextDestinations,
    cart:SetCart,
    nationality:SetCountries,
    nationalityState:SetState,
    forms:SetForms,
    validation:SetValidation,
    toggleModal:ToggleModal,
    toggleSlidePanel:ToggleSlidePanel,
    bookingLoading:BookingLoading,
    hotel:SetHotel
});
  
export default rootReducer;